import { useState, useEffect } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faEyeSlash, faEye } from '@fortawesome/free-solid-svg-icons';

import { useAuth } from '../../contexts/AuthContext';

import axios from 'axios';

const RegisterModal = ({ show, loginModal, onClose, onLoginSuccess }) =>
{
    const [paises, setPaises] = useState([]);
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordConfirmation, setShowPasswordConfirmation] = useState(false);

    // Estados de formulario
    const [request, setRequest] = useState(
    {
        nombre: '',
        institucion: '',
        pais_id: '',
        email: '',
        password: '',
        password_confirmation: ''
    });

    const [errors, setErrors] = useState(
    {
        nombre: '',
        institucion: '',
        pais_id: '',
        email: '',
        password: '',
        password_confirmation: ''
    });

    // Otros estados
    const [responseCode, setResponseCode] = useState('');
    const [loading, setLoading] = useState(false);
    const [resending, setResending] = useState(false);
    const [code, setCode] = useState('');
    const [errorsCode, setErrorsCode] = useState({ email: '', code: '' });
    const [errorMessage, setErrorMessage] = useState('');
    const [verifyMessage, setVerifyMessage] = useState('');

    const apiUrl = process.env.REACT_APP_API_URL;

    const { email, setEmail, message, setMessage, resend, setResend, setToken } = useAuth();

    const fetchPaises = async () =>
    {
        try
        {
            const { data } = await axios.get(`${apiUrl}/usuarios-buscadores/paises`);

            setPaises(data);
        }
        catch (error)
        {
            console.log(error);

            setPaises([]);
        }
    }

    // 1. Función dedicada a limpiar todos los estados
    const handleReset = () =>
    {
        setShowPassword(false);
        setShowPasswordConfirmation(false);

        setRequest(
        {
            nombre: '',
            institucion: '',
            pais_id: 38,
            email: '',
            password: '',
            password_confirmation: ''
        });

        setErrors(
        {
            nombre: '',
            institucion: '',
            pais_id: '',
            email: '',
            password: '',
            password_confirmation: ''
        });

        setResponseCode('');
        setLoading(false);
        setResending(false);
        setCode('');
        setErrorsCode({ email: '', code: '' })
        setErrorMessage('');
        setEmail('');
        setMessage('');
        setResend(false);
        setVerifyMessage('');
    };

    const handleChange = (e) =>
    {
        setRequest(
        {
            ...request,
            [e.target.name]: e.target.value
        });
    }

    const handleSubmit = async (e) =>
    {
        e.preventDefault();

        setErrors(
        {
            nombre: '',
            institucion: '',
            pais_id: '',
            email: '',
            password: ''
        });

        setResponseCode('');

        setLoading(true);

        try
        {
            const { data } = await axios.post(`${apiUrl}/usuarios-buscadores/register`, request);

            const message = data.message;

            setEmail(request.email);

            setRequest(
            {
                nombre: '',
                institucion: '',
                pais_id: '',
                email: '',
                password: '',
                password_confirmation: ''
            })

            setMessage(message);

            setShowPassword(false);
            setShowPasswordConfirmation(false);
            setLoading(false);
        }
        catch (error)
        {
            const { response } = error;

            const { data } = response;

            setErrors(data.errors)

            data.response_code && setResponseCode(data.response_code);

            setLoading(false);
        }
    }

    const handleVerifyCode = async (e) =>
    {
        e.preventDefault();

        setErrorsCode({ email: '', code: '' })
        setErrorMessage('');

        setLoading(true);

        try
        {
            const { data } = await axios.post(`${apiUrl}/usuarios-buscadores/verify-otp`, { email, code });

            const message = data.message;

            setVerifyMessage(message);

            setLoading(false);
        }
        catch (error)
        {
            const { response } = error;

            const { data } = response;

            data.errors ? setErrorsCode(data.errors) : setErrorMessage(data.message);

            setLoading(false);
        }
    }

    const handleResendCode = async () =>
    {
        setResending(true);

        try
        {
            const { data } = await axios.post(`${apiUrl}/usuarios-buscadores/resend-otp`, { email });

            const message = data.message;

            setMessage(message);
            setResending(false);
        }
        catch (error)
        {
            console.log(error);

            setResending(false);
        }
    }

    const handleLogin = () =>
    {
        onClose();

        setMessage('');
        setResend(false);

        setShowPassword(false);
        setShowPasswordConfirmation(false);
        setCode('');
        setVerifyMessage('');

        loginModal();
    }

    // Efecto inicial para cargar países
    useEffect(() =>
    {
        fetchPaises();
    }, []);

    // 2. Efecto para capturar el cierre del modal
    useEffect(() =>
    {
        if (!show) { handleReset(); }
    }, [show]); // Se ejecuta cada vez que 'show' cambia de true a false o viceversa

    if (!show) return null;

    return (
        <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} style={{ backgroundColor: 'rgba(4, 47, 46, 0.75)', backdropFilter: 'blur(8px)', zIndex: 10050 }}>
            <div className="modal-dialog modal-md">
                <div className="modal-content">

                    <div className="modal-header">
                        <h5 className="modal-title fw-medium">{'Registrarse'}</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>

                    {
                        !message ?
                        (
                            <form onSubmit={handleSubmit}>

                                <div className="modal-body">
                                    <div className="row g-3">
                                        <div className="col-md-6 mb-3">
                                            <label style={{ fontSize: '12px', fontWeight: 600 }} htmlFor="nombre" className="form-label">
                                                {'Nombre'}
                                            </label>

                                            <input 
                                                type="input"
                                                name="nombre"
                                                placeholder="Nombre completo"
                                                className={`form-control ${errors.nombre ? 'is-invalid' : ''}`}
                                                id="nombre"
                                                value={request.nombre}
                                                onChange={handleChange}
                                                required
                                                autoComplete="off"
                                            />

                                            {
                                                errors.nombre &&
                                                (
                                                    <div id="nombreFeedback" className="invalid-feedback">
                                                        {errors.nombre}
                                                    </div>
                                                )
                                            }

                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <label style={{ fontSize: '12px', fontWeight: 600 }} htmlFor="nombre" className="form-label">
                                                {'Institución'}
                                            </label>

                                            <input 
                                                type="text"
                                                name="institucion"
                                                placeholder="Su institución asociada"
                                                className={`form-control ${errors.institucion ? 'is-invalid' : ''}`}
                                                id="institucion"
                                                value={request.institucion}
                                                onChange={handleChange}
                                                required
                                                autoComplete="off"
                                            />

                                            {
                                                errors.institucion &&
                                                (
                                                    <div id="nombreFeedback" className="invalid-feedback">
                                                        {errors.institucion}
                                                    </div>
                                                )
                                            }

                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <label style={{ fontSize: '12px', fontWeight: 600 }} htmlFor="pais_id" className="form-label">
                                            {'País'}
                                        </label>

                                        <select
                                            name="pais_id"
                                            className={`form-select ${errors.pais_id ? 'is-invalid' : ''}`}
                                            id="pais_id"
                                            value={request.pais_id}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="" disabled>{'Seleccione un país...'}</option>

                                            {
                                                paises.map((pais) =>
                                                (
                                                    <option key={pais.id} value={pais.id}>{pais.nombre}</option>
                                                ))
                                            }

                                        </select>

                                        {
                                            errors.pais_id &&
                                            (
                                                <div id="paisIdFeedback" className="invalid-feedback">
                                                    {errors.pais_id}
                                                </div>
                                            )
                                        }

                                    </div>

                                    <div className="mb-3">
                                        <label style={{ fontSize: '12px', fontWeight: 600 }} htmlFor="email" className="form-label">
                                            {'Correo Electrónico'}
                                        </label>

                                        <input 
                                            type="email"
                                            name="email"
                                            placeholder="Ingrese su correo"
                                            className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                            id="email"
                                            value={request.email}
                                            onChange={handleChange}
                                            required
                                            autoComplete="off"
                                        />

                                        {
                                            errors.email &&
                                            (
                                                <div id="emailFeedback" className="invalid-feedback">
                                                    {errors.email}

                                                    {
                                                        responseCode === 'pending_verification' &&
                                                        (
                                                            <>
                                                                {' '}
                                                                <a
                                                                    className="link-primary"
                                                                    onClick={() =>
                                                                    {
                                                                        setEmail(request.email);
                                                                        setRequest(
                                                                        {
                                                                            nombre: '',
                                                                            institucion: '',
                                                                            pais_id: '',
                                                                            email: '',
                                                                            password: '',
                                                                            password_confirmation: ''
                                                                        });
                                                                        setMessage('Si necesitas obtener un nuevo código de verificación, presiona en Reenviar código.');
                                                                    }}
                                                                    style={{ cursor: 'pointer' }}
                                                                >{'Por favor, ingresa tu código de verificación aquí.'}</a>
                                                            </>
                                                        )
                                                    }

                                                    {
                                                        responseCode === 'has_been_taken' &&
                                                        (
                                                            <>
                                                                {' '}
                                                                <a
                                                                    className="link-primary"
                                                                    onClick={() =>
                                                                    {
                                                                        setEmail(request.email);
                                                                        setRequest(
                                                                        {
                                                                            nombre: '',
                                                                            institucion: '',
                                                                            pais_id: '',
                                                                            email: '',
                                                                            password: '',
                                                                            password_confirmation: ''
                                                                        });
                                                                        onClose();

                                                                        setCode('');
                                                                        setMessage('');
                                                                        setResend(false);
                                                                        setVerifyMessage('');

                                                                        loginModal();
                                                                    }}
                                                                    style={{ cursor: 'pointer' }}
                                                                >{'¿Deseas iniciar sesión con este correo?'}</a>
                                                            </>
                                                        )
                                                    }

                                                </div>
                                            )
                                        }

                                    </div>

                                    <div className="mb-3">
                                        <label style={{ fontSize: '12px', fontWeight: 600 }} htmlFor="password" className="form-label">
                                            {'Contraseña (minimo 5 caracteres)'}
                                        </label>

                                        {/* Usamos input-group para fusionar el input y el botón primario */}
                                        <div className={`input-group ${errors.password ? 'has-validation' : ''}`}>
                                            <input 
                                                type={showPassword ? "text" : "password"}
                                                name="password"
                                                placeholder="********"
                                                className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                                                id="password"
                                                value={request.password}
                                                onChange={handleChange}
                                                required
                                                autoComplete="off"
                                            />

                                            {/* Botón Primario de Bootstrap con el icono blanco */}
                                            <button
                                                type="button"
                                                className="btn btn-primary btn-sm bg-marine-600"
                                                onClick={() => setShowPassword(!showPassword)}
                                            >
                                                {/* Iconos de FontAwesome condicionales */}
                                                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                                            </button>

                                            {/* El feedback de error ahora queda integrado perfectamente gracias a 'has-validation' */}
                                            {
                                                errors.password &&
                                                (
                                                    <div id="emailFeedback" className="invalid-feedback">
                                                        {errors.password}
                                                    </div>
                                                )
                                            }

                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <label style={{ fontSize: '12px', fontWeight: 600 }} htmlFor="password" className="form-label">
                                            {'Confirme su contraseña'}
                                        </label>

                                        {/* Usamos input-group para fusionar el input y el botón primario */}
                                        <div className={`input-group ${errors.password ? 'has-validation' : ''}`}>
                                            <input 
                                                type={showPasswordConfirmation ? "text" : "password"}
                                                name="password_confirmation"
                                                placeholder="********"
                                                className={`form-control ${errors.password_confirmation ? 'is-invalid' : ''}`}
                                                id="password_confirmation"
                                                value={request.password_confirmation}
                                                onChange={handleChange}
                                                required
                                                autoComplete="off"
                                            />

                                            {/* Botón Primario de Bootstrap con el icono blanco */}
                                            <button
                                                type="button"
                                                className="btn btn-primary btn-sm bg-marine-600"
                                                onClick={() => setShowPasswordConfirmation(!showPasswordConfirmation)}
                                            >
                                                {/* Iconos de FontAwesome condicionales */}
                                                <FontAwesomeIcon icon={showPasswordConfirmation ? faEyeSlash : faEye} />
                                            </button>

                                            {/* El feedback de error ahora queda integrado perfectamente gracias a 'has-validation' */}
                                            {
                                                errors.password_confirmation &&
                                                (
                                                    <div id="emailFeedback" className="invalid-feedback">
                                                        {errors.password_confirmation}
                                                    </div>
                                                )
                                            }

                                        </div>
                                    </div>
                                </div>

                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary px-4 uppercase fw-semibold" style={{ fontSize: '12px' }} onClick={handleLogin} disabled={loading}>{'Volver e iniciar sesión'}</button>
                                    <button className="btn btn-primary fw-semibold bg-marine-600" style={{ fontSize: '12px' }} disabled={loading}>{`${!loading ? 'Registrar cuenta' : 'Registrando cuenta...'}`}</button>
                                </div>

                            </form>
                        ) :
                        (
                            <>
                                <form onSubmit={handleVerifyCode}>

                                    <div className="modal-body">

                                        {
                                            !verifyMessage ?
                                            (
                                                <div className="alert alert-primary text-center" role="alert">
                                                    {message}
                                                </div>
                                            ) :
                                            (
                                                <div className="alert alert-primary text-center" role="alert">
                                                    {verifyMessage}
                                                </div>
                                            )
                                        }

                                        <div className="mb-3">
                                            <label style={{ fontSize: '12px', fontWeight: 600 }} htmlFor="mail" className="form-label">
                                                {'Correo Electrónico'}
                                            </label>

                                            <input 
                                                type="email"
                                                name="email"
                                                placeholder="Ingrese su correo"
                                                className={`form-control ${errorsCode.email ? 'is-invalid' : ''}`}
                                                id="mail"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                readOnly={!resend}
                                                required={resend}
                                                autoComplete="off"
                                            />

                                            {
                                                errorsCode.email &&
                                                (
                                                    <div id="emailFeedback" className="invalid-feedback">
                                                        {errorsCode.email}
                                                    </div>
                                                )
                                            }

                                        </div>

                                        <div className="mb-3">
                                            <label style={{ fontSize: '12px', fontWeight: 600 }} htmlFor="code" className="form-label">
                                                {'Código de Verificación'}
                                            </label>

                                            <input 
                                                type="password"
                                                name="code"
                                                placeholder="Ingrese su código de verificación"
                                                className={`form-control ${errorsCode.code || errorMessage ? 'is-invalid' : ''}`}
                                                id="code"
                                                value={code}
                                                onChange={(e) => setCode(e.target.value)}
                                                required
                                                readOnly={verifyMessage}
                                                autoComplete="off"
                                            />

                                            {
                                                (errorsCode.code || errorMessage) &&
                                                (
                                                    <div id="emailFeedback" className="invalid-feedback">
                                                        {errorsCode.code || errorMessage}
                                                    </div>
                                                )
                                            }

                                        </div>
                                    </div>

                                    <div className="modal-footer">

                                        {
                                            !verifyMessage ?
                                            (
                                                <>
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary fw-semibold"
                                                        style={{ fontSize: '12px' }}
                                                        onClick={handleResendCode}
                                                        disabled={loading || resending}
                                                    >
                                                        {`${!resending ? 'Reenviar código' : 'Reenviando código...'}`}
                                                    </button>
                                                    <button
                                                        type="submit"
                                                        className="btn btn-primary fw-semibold bg-marine-600"
                                                        style={{ fontSize: '12px' }}
                                                        disabled={loading || resending}
                                                    >
                                                        {`${!loading ? 'Verificar' : 'Verificando...'}`}
                                                    </button>
                                                </>
                                            ) :
                                            (
                                                <button type="button" className="btn btn-secondary px-4 uppercase fw-semibold" style={{ fontSize: '12px' }} onClick={handleLogin}>
                                                    {'Volver e iniciar sesión'}
                                                </button>
                                            )
                                        }

                                    </div>

                                </form>
                            </>
                        )
                    }

                </div>
            </div>
        </div>
    );
}

export default RegisterModal;
